import { memo } from 'react';
import { motion } from 'framer-motion';
import { CircleFadingPlus, ArrowRight } from 'lucide-react';
import { DeviceTypeInfo } from '@repo/shared/dtos/devices/DeviceConnectionDto';
import { DeviceType } from '../../../hooks/devices/types';

interface DeviceTypeItemProps {
  type: DeviceTypeInfo;
  onAddDevice: (type: DeviceType) => void;
}

export const DeviceTypeItem = memo(({ type, onAddDevice }: DeviceTypeItemProps) => {
  const deviceType = type.devicename as DeviceType;

  const handleAddDevice = () => {
    onAddDevice(deviceType);
  };

  return (
    <motion.button
      onClick={handleAddDevice}
      className="flex w-full items-center rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface)] p-3 text-[var(--anl-text)] transition-all hover:border-[var(--anl-accent)] hover:bg-[var(--anl-surface-elev)]"
      whileHover={{ scale: 1.01 }}
      aria-label={`Connect ${type.devicename}`}
    >
      <div
        className="mr-3 flex h-10 w-10 items-center justify-center rounded-full bg-[var(--anl-surface-elev)]"
        aria-hidden="true"
      >
        <CircleFadingPlus className="h-5 w-5 text-[var(--anl-accent)]" />
      </div>
      <div className="flex-1 text-left">
        <span className="font-medium text-[var(--anl-text)]">{type.devicename}</span>
        {type.devicedesc && (
          <div className="text-xs text-[var(--anl-text-muted)]">{type.devicedesc}</div>
        )}
        <div className="text-xs text-[var(--anl-text-muted)]">Click to connect</div>
      </div>
      <ArrowRight className="h-4 w-4 text-[var(--anl-text-muted)]" aria-hidden="true" />
    </motion.button>
  );
});

DeviceTypeItem.displayName = 'DeviceTypeItem';
